import { Procedure } from "../../../../types/procedures";
import { uploadedImageThumbPath } from "../../../../utils/uploadedImage";
import { useQuote } from "../../QuoteProvider";
import { useGetProceduresByType } from "../../hooks/useGetProceduresByType";
import "./quote-procedures-list.css";
import ProcedureElement from "./ProcedureElement";
// @ts-ignore - useTranslation with namespace parameter
import { useTranslation } from "react-i18next";

type QuoteProceduresListParams = {
  procedureType: string;
  setStoryProcedure?: (procedure: Procedure) => void;
};

const QuoteProceduresList = ({
  procedureType,
  setStoryProcedure,
}: QuoteProceduresListParams) => {
  const proceduresByType = useGetProceduresByType({ procedureType });
  const {
    selectedProcedures,
    addSelectedProcedure,
    removeSelectedProcedure,
    gender,
  } = useQuote();
  // @ts-ignore - useTranslation with namespace parameter
  const { t } = useTranslation("quote");

  // Belt and suspenders next to the type-list filter in StepSelectProcedureV2:
  // the gender filter inside useGetProceduresByType can empty a category that
  // did have procedures behind it, and a bare empty grid reads as broken.
  if (proceduresByType.length === 0) {
    return (
      <div className="procedures-list-empty">
        {t("procedures.noProceduresInType", {
          defaultValue:
            "No procedures are available in this category yet. Please pick another category.",
        })}
      </div>
    );
  }

  return (
    <div className="procedures-list">
      {proceduresByType.map((procedure: Procedure) => {
        const procedureImage =
          gender === "MALE"
            ? procedure.maleImage
            : procedure.image
              ? procedure.image
              : procedure.maleImage;

        // 240px covers 2× retina at the largest mobile display width
        // (~114px wide; Lighthouse Moto G profile is the scoring target).
        // Started at 400 but Lighthouse flagged that as ~2× too big.
        const imageUrl = procedureImage
          ? uploadedImageThumbPath(procedureImage, 240)
          : undefined;

        const isSelected = selectedProcedures.includes(procedure);

        // isDisabled - look in all the selectedProcedures for incompatibleProcedures and if found, disable this procedure
        const isDisabled = selectedProcedures.some((selectedProcedure) => {
          return (
            selectedProcedure.incompatibleProcedures?.some(
              (incompatibleProcedure) =>
                incompatibleProcedure.id === procedure.id,
            ) ||
            procedure.incompatibleProcedures?.some((incompatibleProcedure) =>
              selectedProcedure.id === incompatibleProcedure.id ? true : false,
            )
          );
        });

        const procedureElement = (
          <ProcedureElement
            procedure={procedure}
            isSelected={isSelected}
            isDisabled={isDisabled}
            removeSelectedProcedure={removeSelectedProcedure}
            addSelectedProcedure={addSelectedProcedure}
            imageUrl={imageUrl}
            setStoryProcedure={setStoryProcedure}
            selectedCount={selectedProcedures.length}
          />
        );

        return <div key={procedure.id}>{procedureElement}</div>;
      })}
    </div>
  );
};

export default QuoteProceduresList;
